import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { moneyFlowService } from '../../../services'
import { parseHttpError } from '../../utils'
import { parseExpenditureTypes } from './utils'
import { selectors } from './selectors'
import { TExpenditureTypesState } from '../../types'
import { expenditureTypesAdapter } from './adapter'

const name = 'expenditureTypes'

const initialState: TExpenditureTypesState = {
    ...expenditureTypesAdapter.getInitialState(),
    isFetching: false
}

const fetch = createAsyncThunk(
    `${name}/fetch`,
    async () => {
        return parseExpenditureTypes(await moneyFlowService.fetchExpenditureTypes())
    },
    {
        serializeError: parseHttpError
    }
)

const slice = createSlice({
    name,
    initialState,
    reducers: {},
    extraReducers: (builder) =>
        builder
            .addCase(fetch.pending, (state) => {
                state.isFetching = true
                state.fetchError = undefined
            })
            .addCase(fetch.fulfilled, (state, action) => {
                state.isFetching = false
                expenditureTypesAdapter.setAll(state, action.payload)
            })
            .addCase(fetch.rejected, (state, action) => {
                state.isFetching = false
                state.fetchError = action.error
            })
})

export const expenditureTypes = {
    name: slice.name,
    actions: {
        fetch,
    },
    reducer: slice.reducer,
    selectors,
}